export const nftsSlice = set => ({
  nfts: null,
  setNfts: nfts => set(() => ({ nfts })),
})
